<template>
 <v-card>
   <v-card-text>
    <v-form @submit.prevent="validateEmail" >
      <v-row >
        <v-col cols="8" >

          <v-text-field filled persistent-hint
            label='email'
            type="email"
            hint="Your team member's work email address"
            v-model="email" />

        </v-col>
        <v-col cols="4" >
          <v-btn
            :disabled="!email"
            :loading="requests.validate.loading"
            @click="validateEmail" block class="mt-2" >Validate</v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-card-text>
</v-card>
</template>
<script>
const INVITE_TYPES = {
  NEW: 'NEW',
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
}

export default {
  name: 'ValidateEmail',
  data () {
    return {
      step: 1,
      email: null,
      req: {
        resource: 'ag.spaces.practitioner'
      },
      requests: {
        validate: {
          resource: 'ag.team',
          extra: 'validate',
          method: 'post'
        }
      }
    }
  },
  watch: {
    inviteType () {
      this.$emit('validated', {email: this.email, type: this.inviteType})
    }
  },
  computed: {
    validationResult () { return this.requests.validate.result },
    inviteType () {
      let r = this.validationResult
      if (!r) { return null }
      if (r.exists === false) { return INVITE_TYPES.NEW }
      if (r.profile_exists === false || r.profile_active === false) {
        return INVITE_TYPES.INACTIVE
      }
      return INVITE_TYPES.ACTIVE
    }
  },
  methods: {
    validateEmail () {
      this.requests.validate.data = {email: this.email}
      this.$request('save', this.requests.validate)
    }
  }
}
</script>
